import { useSelector } from 'react-redux';
import { RootState } from '../storage/store';

const useIsPaymentsUnavailable = () => {
  const { payments } = useSelector((state: RootState) => state.application);
  const { paymentsAvailability } = payments;
  return {
    isPaymentUnavailable: paymentsAvailability === false
  };
};

export default useIsPaymentsUnavailable;
